import React from "react";
import { Box } from "@mui/material";

const Card1 = () => {
  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: "repeat(5, 40px)",
        justifyContent: "center",
        alignItems: "center",
        paddingTop: 2,
      }}
    >
      <Box
        sx={{
          gridColumn: "3",
          gridRow: "3",
          width: 43,
          height: 54,
          backgroundColor: "#1976d2",
          borderRadius: "10px",
          color: "white",
          fontWeight: "bold",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          userSelect: "none",
        }}
      >
        1
      </Box>
    </Box>
  );
};

export default Card1;
